import { useEffect, useMemo } from "react"
import { css } from "@emotion/react"
import { Button, Layout, Modal, Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

interface PhotoConfirmModalProps {
    isOpen: boolean
    photoFile: File | null
    onConfirm: () => void
    onRetake: () => void
}

export const PhotoConfirmModal = ({
    isOpen,
    photoFile,
    onConfirm,
    onRetake
}: PhotoConfirmModalProps) => {
    const { t } = useTranslation()
    const previewUrl = useMemo(
        () => (photoFile ? URL.createObjectURL(photoFile) : ""),
        [photoFile]
    )

    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl)
            }
        }
    }, [previewUrl])
    return (
        <Modal
            open={isOpen}
            backdrop
            header={
                <Typography variant="h4" bolder align="center">
                    {t("キーボックス撮影")}
                </Typography>
            }
            body={
                <div
                    css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                        max-width: 75vw;
                        height: 60vh;
                        padding: 8px;
                        overflow-y: auto;
                    `}
                >
                    <Typography variant="h4" bolder align="center">
                        {t("こちらでよろしいですか？")}
                    </Typography>
                    <Typography align="center">
                        {t(
                            "変更後の番号がわかるように、番号が全て写るように撮影してください。"
                        )}
                    </Typography>
                    <img
                        src={previewUrl}
                        alt={t("撮影した写真")}
                        css={css`
                            max-width: 100%;
                            height: auto;
                        `}
                    />
                </div>
            }
            footer={
                <Layout.Column gap={2}>
                    <Button
                        variant="filled"
                        color="primary"
                        onClick={onConfirm}
                        fullWidth
                    >
                        OK
                    </Button>
                    <Button
                        variant="filled"
                        color="default"
                        onClick={onRetake}
                        fullWidth
                    >
                        {t("撮り直しまたはアップロード")}
                    </Button>
                </Layout.Column>
            }
        />
    )
}
